/* Velt P4: surgimento suave, troca de foto do banner, carrossel de arrastar com barrinha e colunas do rodapé. */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('vp-js');
  window.vpReady = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 1024px)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* Surgimento suave: uma vez por elemento; com "menos movimento" tudo aparece direto. */
  function revealAll() {
    document.querySelectorAll('[data-vp-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }
  function initReveal() {
    var items = document.querySelectorAll('[data-vp-reveal]:not(.is-in)');
    if (!items.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }
  if (reduce.addEventListener) reduce.addEventListener('change', function (e) { if (e.matches) revealAll(); });

  /* Carrossel: arrasta com o mouse (o toque e o trackpad já rolam sozinhos) e mostra o progresso. */
  function initRail(rail) {
    if (rail.dataset.vpReady) return;
    rail.dataset.vpReady = '1';
    var bar = rail.parentElement.querySelector('[data-vp-progress]');
    var ticking = false;

    function update() {
      ticking = false;
      if (!bar) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var visible = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
      var track = bar.parentElement.clientWidth;
      var width = Math.max(visible, 0.08) * track;
      var pos = max > 0 ? rail.scrollLeft / max : 0;
      bar.style.width = width + 'px';
      bar.style.transform = 'translateX(' + (pos * (track - width)) + 'px)';
      bar.parentElement.style.visibility = max > 2 ? 'visible' : 'hidden';
    }
    function request() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    rail.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();

    var down = false, moved = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !finePointer.matches) return;
      down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; rail.classList.add('is-dragging'); }
      if (moved) { rail.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        setTimeout(function () { rail.classList.remove('is-dragging'); }, 0);
      }
    });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* Banner: a foto grande troca entre duas a cada 6,5 s, com esmaecer. Controle "‹ 01 / 02 ›" (setas e número da foto
     atual) e, no celular, deslize do dedo para os lados (a rolagem vertical continua com o navegador). Pausa com o mouse
     em cima, com o foco do teclado no controle e com a aba escondida; com "menos movimento" só troca na mão.
     A 2ª foto só baixa depois da 1ª. */
  var HERO_TEMPO = 6500;
  var HERO_ARRASTO = 40;
  function initHero(box) {
    if (box.dataset.vpReady) return;
    box.dataset.vpReady = '1';
    var slides = box.querySelectorAll('[data-vp-hero-slide]');
    if (slides.length < 2) return;
    var total = slides.length;
    var numero = box.querySelector('[data-vp-hero-atual]');
    var leitor = box.querySelector('[data-vp-hero-leitor]');
    var atual = 0, timer = null, pronta = false, pedida = false, sobre = false, foco = false;

    function doisDigitos(n) { return (n < 10 ? '0' : '') + n; }
    /* naMao: troca pedida pela pessoa (seta ou dedo); só aí o leitor de tela anuncia a foto nova */
    function mostrar(n, naMao) {
      atual = (n + total) % total;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === atual);
        if (i === atual) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      if (numero) numero.textContent = doisDigitos(atual + 1);
      if (leitor) {
        leitor.setAttribute('aria-live', naMao ? 'polite' : 'off');
        leitor.textContent = 'Foto ' + (atual + 1) + ' de ' + total;
      }
      if (naMao) carregar2();
    }
    function agendar() {
      clearTimeout(timer);
      if (!box.isConnected || !pronta || sobre || foco || reduce.matches || document.hidden) return;
      timer = setTimeout(function () { mostrar(atual + 1, false); agendar(); }, HERO_TEMPO);
    }
    function passo(d) { mostrar(atual + d, true); agendar(); }
    var anterior = box.querySelector('[data-vp-hero-prev]');
    var proxima = box.querySelector('[data-vp-hero-next]');
    if (anterior) anterior.addEventListener('click', function () { passo(-1); });
    if (proxima) proxima.addEventListener('click', function () { passo(1); });

    /* Pausa: mouse de verdade em cima (no celular o toque não conta) e foco vindo do teclado */
    function focoDeTeclado(el) { try { return el.matches(':focus-visible'); } catch (e) { return true; } }
    box.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { sobre = true; agendar(); } });
    box.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { sobre = false; agendar(); } });
    box.addEventListener('focusin', function (e) { if (focoDeTeclado(e.target)) { foco = true; agendar(); } });
    box.addEventListener('focusout', function (e) { if (!box.contains(e.relatedTarget)) { foco = false; agendar(); } });
    document.addEventListener('visibilitychange', agendar);
    if (reduce.addEventListener) reduce.addEventListener('change', agendar);

    /* Deslize com o dedo: pelo menos 40 px para os lados e bem mais horizontal que vertical. Se a pessoa estiver
       rolando a página, o navegador cancela o gesto (pointercancel) e nada troca. */
    var x0 = null, y0 = 0;
    box.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' || e.target.closest('.vp-hero__ctrl')) return;
      x0 = e.clientX; y0 = e.clientY;
    });
    box.addEventListener('pointerup', function (e) {
      if (x0 === null || e.pointerType !== 'touch') return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) >= HERO_ARRASTO && Math.abs(dx) > Math.abs(dy) * 1.5) passo(dx < 0 ? 1 : -1);
    });
    box.addEventListener('pointercancel', function () { x0 = null; });

    var img1 = slides[0].querySelector('img');
    var img2 = slides[1].querySelector('img');
    function carregar2() {
      if (!img2 || pedida) return;
      pedida = true;
      img2.addEventListener('load', function () { pronta = true; agendar(); }, { once: true });
      img2.loading = 'eager';
      if (img2.dataset.srcset) img2.srcset = img2.dataset.srcset;
      if (img2.dataset.src) img2.src = img2.dataset.src;
    }
    function depoisDa1() {
      if ('requestIdleCallback' in window) requestIdleCallback(carregar2, { timeout: 2000 });
      else setTimeout(carregar2, 300);
    }
    if (img1 && !img1.complete) img1.addEventListener('load', depoisDa1, { once: true });
    else depoisDa1();
  }

  /* Página de produto: Pix, economia e parcelas acompanham o tamanho escolhido. Os valores de cada variante vêm
     prontos do Liquid (velt-p4-preco-produto, mesmo cálculo e formato da vitrine); aqui só troca o texto. */
  function initPrecoProduto() {
    document.querySelectorAll('[data-vp-ppix]').forEach(function (box) {
      if (box.dataset.vpReady) return;
      box.dataset.vpReady = '1';
      var mapa;
      try { mapa = JSON.parse(box.querySelector('[data-vp-ppix-mapa]').textContent); } catch (e) { return; }
      var campos = { pix: '[data-vp-ppix-pix]', eco: '[data-vp-ppix-eco]', parc: '[data-vp-ppix-parc]' };
      document.addEventListener('variant:changed', function (e) {
        var v = e.detail && e.detail.variant && mapa[String(e.detail.variant.id)];
        if (!v || !box.isConnected) return;
        Object.keys(campos).forEach(function (k) {
          var el = box.querySelector(campos[k]);
          if (el && v[k]) el.textContent = v[k];
        });
      });
    });
  }

  /* Barra fixa "Comprar": a caixinha mostra só o tamanho; o preço fica ao lado e segue a opção escolhida
     (na própria barra ou no seletor da página, que o Minimog copia para a barra). */
  function initBarraPreco() {
    document.querySelectorAll('[data-vp-satc-preco]').forEach(function (el) {
      if (el.dataset.vpReady) return;
      el.dataset.vpReady = '1';
      var sel = el.parentNode.querySelector('select[name="id"]');
      if (!sel) return;
      function atualizar() {
        var op = sel.options[sel.selectedIndex];
        if (op && op.dataset.vpPreco) el.textContent = op.dataset.vpPreco;
      }
      sel.addEventListener('change', atualizar);
      document.addEventListener('variant:changed', function () { setTimeout(atualizar, 0); });
    });
  }

  /* Página de produto: "VEJA TAMBÉM" vem da API de recomendações da Shopify, já com o cartão da Velt. */
  function initRecs() {
    document.querySelectorAll('[data-vp-recs][data-url]').forEach(function (sec) {
      if (sec.dataset.vpReady) return;
      sec.dataset.vpReady = '1';
      fetch(sec.dataset.url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var novo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-vp-recs]');
          if (novo && novo.querySelector('.vp-card')) { sec.innerHTML = novo.innerHTML; initReveal(); }
        })
        .catch(function () {});
    });
  }

  /* Página de produto: "VISTOS POR ÚLTIMO" guarda os últimos produtos no navegador e busca o cartão de cada um. */
  var VISTOS = 'vp_vistos';
  function lerVistos() { try { return JSON.parse(localStorage.getItem(VISTOS) || '[]') || []; } catch (e) { return []; } }
  function gravarVistos(lista) { try { localStorage.setItem(VISTOS, JSON.stringify(lista)); } catch (e) {} }
  function initVistos() {
    var sec = document.querySelector('[data-vp-vistos]');
    if (!sec || sec.dataset.vpReady) return;
    sec.dataset.vpReady = '1';
    var atual = sec.dataset.atual;
    var limite = parseInt(sec.dataset.limite || '8', 10);
    var anteriores = lerVistos().filter(function (h) { return h && h !== atual; });
    if (atual) gravarVistos([atual].concat(anteriores).slice(0, 12));
    var alvo = sec.querySelector('[data-vp-vistos-lista]');
    var pedir = anteriores.slice(0, limite);
    if (!alvo || !pedir.length) return;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(pedir.map(function (h) {
      return fetch(base + 'products/' + encodeURIComponent(h) + '?view=velt-p4-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var n = 0;
      htmls.forEach(function (html) {
        if (html && html.indexOf('vp-card') > -1) {
          var li = document.createElement('li');
          li.className = 'vp-rail__item';
          li.innerHTML = html;
          alvo.appendChild(li);
          n++;
        }
      });
      if (n) { sec.hidden = false; initRail(sec.querySelector('[data-vp-rail]')); }
    });
  }

  /* Página de coleção: só as 4 ordenações do pacote, com nomes curtos. Reaplica quando o tema recarrega a barra. */
  var ORDEM = { 'best-selling': 'Mais vendidos', 'created-descending': 'Novidades', 'price-ascending': 'Menor preço', 'price-descending': 'Maior preço' };
  var NOMES_ANTIGOS = { 'Data, mais recente primeiro': 'Novidades', 'Preço, ordem crescente': 'Menor preço', 'Preço, ordem decrescente': 'Maior preço' };
  function ajustarOrdenacao(raiz) {
    raiz.querySelectorAll('.m-select-custom--option[data-value], .m-sortby-mobile--item[data-value]').forEach(function (el) {
      var v = el.getAttribute('data-value');
      if (!ORDEM[v]) { el.remove(); return; }
      if (el.textContent.trim() && el.textContent.trim() !== ORDEM[v]) el.textContent = ORDEM[v];
    });
    raiz.querySelectorAll('select[name="sort_by"] option').forEach(function (o) {
      if (!ORDEM[o.value]) o.remove();
      else if (o.textContent !== ORDEM[o.value]) o.textContent = ORDEM[o.value];
    });
    var walker = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) {
      var t = n.nodeValue.trim();
      if (NOMES_ANTIGOS[t]) n.nodeValue = n.nodeValue.replace(t, NOMES_ANTIGOS[t]);
    }
  }
  function initOrdenacao() {
    var sec = document.querySelector('.facest-filters-section');
    if (!sec || sec.dataset.vpOrdem) return;
    sec.dataset.vpOrdem = '1';
    ajustarOrdenacao(sec);
    var pendente = false;
    new MutationObserver(function () {
      if (pendente) return;
      pendente = true;
      requestAnimationFrame(function () { pendente = false; ajustarOrdenacao(sec); });
    }).observe(sec, { childList: true, subtree: true });
  }

  /* Rodapé: no computador as colunas ficam sempre abertas; no celular abrem e fecham. */
  function syncFooter() {
    document.querySelectorAll('[data-vp-foot-col]').forEach(function (d) {
      if (desktop.matches) d.setAttribute('open', '');
      else if (!d.dataset.vpTouched) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('[data-vp-foot-col] > summary');
    if (!s) return;
    if (desktop.matches) { e.preventDefault(); return; }
    s.parentElement.dataset.vpTouched = '1';
  });
  if (desktop.addEventListener) desktop.addEventListener('change', syncFooter);

  /* Carrinho: "Continuar comprando" fecha a gaveta usando o próprio botão de fechar do tema. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vp-fechar-carrinho]');
    if (!b) return;
    e.preventDefault();
    var fechar = document.querySelector('.m-cart-drawer__close');
    if (fechar) fechar.click();
  });

  function init() {
    initReveal();
    document.querySelectorAll('[data-vp-hero]').forEach(initHero);
    document.querySelectorAll('[data-vp-rail]').forEach(function (r) { if (!r.closest('[hidden]')) initRail(r); });
    initPrecoProduto();
    initBarraPreco();
    initRecs();
    initVistos();
    initOrdenacao();
    syncFooter();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Editor da Shopify: reinicia quando uma seção é recarregada. */
  document.addEventListener('shopify:section:load', init);
})();
